import ColorJs from 'colorjs.io';

type RgbaColor = {
  alpha: number;
  toString: () => string;
};

const Color = ColorJs as unknown as new (color: string) => RgbaColor;

export const rgba = (hex: string, alpha: number) => {
  const color = new Color(hex);
  color.alpha = alpha;
  return color.toString();
};
